import request from "@/utils/request";

//编辑专家账号信息
export function expertinfo(data) {
    return request({
      url: 'zwb/app/edit/expertinfo',
      method: 'post',
      data
    })
}
// 专家提问收入明细
export function queryExpertIncomeList(data) {
  return request({
    url: 'zwb/app/account/queryExpertIncomeList',
    method: 'post',
    data
  })
}

//查询专家问题
export function question(data) {
  return request({
    url: 'zwb/app/page/expert/question',
    method: 'post',
    data
  })
}

//专家追答问题
export function answer(data) {
  return request({
    url: 'zwb/app/examine/minutely/answer',
    method: 'post',
    data
  })
}


//查询课程
export function expertCollege(data) {
    return request({
      url: 'zwb/app/mycollege/list',
      method: 'post',
      data
    })
}

//专家报名的活动
export function expertList(data) {
  return request({
    url: 'zwb/app/myactivity/expert/list',
    method: 'post',
    data
  })
}
//发布文章
export function release(data) {
  return request({
    url: 'zwb/app/mytechnology/release',
    method: 'post',
    data
  })
}

//分页查询文章
export function releaseList(data) {
  return request({
    url: 'zwb/app/mytechnology/list',
    method: 'post',
    data
  })
}



//编辑文章
export function releaseEdit(data) {
  return request({
    url: 'zwb/app/mytechnology/modify',
    method: 'post',
    data
  })
}

//删除文章
export function releaseDel(params) {
  return request({
    url: 'zwb/app/mytechnology/del',
    method: 'get',
    params
  })
}


//分页查询问题
export function questionList(data) {
  return request({
    url: 'zwb/app/page/expert/question',
    method: 'post',
    data
  })
}
//公共查询专家回答的问题
export function questionLists(data) {
  return request({
    url: 'zwb/app/page/public/expert/question',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/expert.js